"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Speech(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 2c5.607 0 10 3.953 10 9 0 5.202-4.455 9.435-9.932 9.435-.827 0-1.647-.094-2.444-.279-1.64 1.242-4.22 1.842-5.814 1.842-.487 0-.881-.056-1.129-.167C2.25 21.64 1.99 21.244 2 20.8c.02-.782.787-1.08 1.038-1.178.895-.347 1.329-1.59 1.489-2.36C2.933 15.553 2 13.246 2 11c0-5.047 4.393-9 10-9zm0 2c-4.486 0-8 3.075-8 7 0 1.816.835 3.769 2.179 5.093l.095.089a.999.999 0 0 1 .315.823c-.009.091-.148 1.478-.877 2.727 1.059-.252 2.233-.696 2.979-1.401.257-.243.627-.332.964-.234l.165.048c.729.192 1.485.29 2.248.29C16.368 18.435 20 15.03 20 11c0-3.925-3.514-7-8-7zm3.24 8H8.817a1 1 0 1 1 0-2h6.421a1 1 0 1 1 0 2", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Speech;
